import { render, staticRenderFns } from "./RedeemStats.vue?vue&type=template&id=5955cb0c&"
import script from "./RedeemStats.vue?vue&type=script&lang=js&"
export * from "./RedeemStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports